import { forwardRef, memo, useImperativeHandle, useState } from 'react';
import { SwiperSwitchRightSvg, SwiperSwitchLeftSvg } from '@/sub-luca-plugin/compatible-components/svg-icons';
import './index.scss';

export type TDirection = 'left' | 'right';

export interface IControlScrollBtnsRef {
    controlLeftBtn: (visible: boolean) => void;
    controlRightBtn: (visible: boolean) => void;
}

interface IProps {
    onScrollTo: (type: TDirection) => void;
}

const ControlScrollBtns = ({ onScrollTo }: IProps, ref: any) => {
    const [leftBtnVisible, setLeftBtnVisible] = useState(false);
    const [rightBtnVisible, setRightBtnVisible] = useState(false);

    useImperativeHandle(
        ref,
        (): IControlScrollBtnsRef => ({
            controlLeftBtn: visible => setLeftBtnVisible(visible),
            controlRightBtn: visible => setRightBtnVisible(visible),
        }),
        []
    );

    return (
        <>
            {leftBtnVisible && (
                <>
                    <div className="subject-search__knowledge-slice-left-overlay" />
                    <div className="subject-search__knowledge-slice-left" onClick={() => onScrollTo('left')}>
                        <SwiperSwitchLeftSvg />
                    </div>
                </>
            )}
            {rightBtnVisible && (
                <>
                    <div className="subject-search__knowledge-slice-right-overlay" />
                    <div className="subject-search__knowledge-slice-right" onClick={() => onScrollTo('right')}>
                        <SwiperSwitchRightSvg />
                    </div>
                </>
            )}
        </>
    );
};

export default memo(forwardRef(ControlScrollBtns));
